import type { CheckoutDraftDTO } from "../../api/types.js";
import { formatPrice } from "../../lib/format.js";
import { messages } from "../../i18n/messages.js";
import { AppButton } from "../ui/AppButton.js";

interface CheckoutSuccessStateProps {
  result: CheckoutDraftDTO;
  onBrowseCatalog: () => void;
}

export function CheckoutSuccessState({ result, onBrowseCatalog }: CheckoutSuccessStateProps) {
  return (
    <section className="flex flex-1 flex-col gap-4 px-4 py-4">
      <div className="rounded-[18px] bg-[var(--tg-theme-secondary-bg-color,#f4f4f5)] p-4">
        <h2 className="text-lg font-semibold">{messages.checkout.successTitle}</h2>
        <p className="mt-2 text-sm opacity-70">{messages.checkout.successBody}</p>
      </div>

      <dl className="space-y-2 rounded-[16px] border border-black/5 p-4 text-sm">
        <div className="flex justify-between gap-4">
          <dt className="opacity-60">{messages.checkout.orderNumberLabel}</dt>
          <dd className="font-mono text-xs">{result.checkout_id}</dd>
        </div>
        {result.manager_task_id ? (
          <div className="flex justify-between gap-4">
            <dt className="opacity-60">{messages.checkout.managerTaskLabel}</dt>
            <dd className="font-mono text-xs">{result.manager_task_id.slice(0, 8)}…</dd>
          </div>
        ) : null}
        <div className="flex justify-between gap-4">
          <dt className="opacity-60">{messages.cart.total}</dt>
          <dd className="font-semibold">{formatPrice(result.totals.total, result.totals.currency)}</dd>
        </div>
      </dl>

      <AppButton className="mt-auto" onClick={onBrowseCatalog}>
        {messages.checkout.backToCatalog}
      </AppButton>
    </section>
  );
}
